import { render } from "./Submenu.vue?vue&type=template&id=49fc1d57"
import script from "./Submenu.vue?vue&type=script&lang=js"
export * from "./Submenu.vue?vue&type=script&lang=js"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/vab/components/VabMenu/components/Submenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "49fc1d57"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('49fc1d57', __exports__)) {
    console.log('reload')
    api.reload('49fc1d57', __exports__)
  }
  
  module.hot.accept("./Submenu.vue?vue&type=template&id=49fc1d57", () => {
    console.log('re-render')
    api.rerender('49fc1d57', render)
  })

}


export default __exports__